import { render, staticRenderFns } from "./Epaper.vue?vue&type=template&id=fb59f90e&scoped=true&lang=pug"
import script from "./Epaper.vue?vue&type=script&lang=js"
export * from "./Epaper.vue?vue&type=script&lang=js"
import style0 from "./Epaper.vue?vue&type=style&index=0&id=fb59f90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb59f90e",
  null
  
)

export default component.exports